// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './utils/flexible.js'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2' //复制
import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'
import Calendar from 'vue-mobile-calendar'//日期组件
import Datepick from 'vue2-datepick';
import VueQriously from 'vue-qriously' //二维码
import { DatetimePicker } from 'mint-ui';
import 'mint-ui/lib/style.css'
import * as filters from './utils/filters.js'

Vue.use(VueQriously)

import VueI18n from 'vue-i18n'
import md5 from 'js-md5'
import sha1 from 'js-sha1'

Vue.use(VueI18n)
Vue.use(Calendar)
Vue.use(Datepick);

Vue.prototype.$md5 = md5;
Vue.prototype.$sha1 = sha1;


Vue.component(DatetimePicker.name, DatetimePicker);

if(localStorage.getItem('user_lang') == null){
  localStorage.setItem('user_lang','en')
}
const i18n = new VueI18n({
	locale: window.localStorage.getItem('user_lang') == null ? "en" : window.localStorage.getItem('user_lang'),
	messages: {
    'zh': require('./utils/lang/zh'), // 中文语言包
    'tw': require('./utils/lang/ft'), // 繁体语言包
		'en': require('./utils/lang/en'), // 英文语言包
    'jp': require('./utils/lang/jp'), // 日语语言包
    'es': require('./utils/lang/xby'), // 西班牙语言包
    'th': require('./utils/lang/ty'), // 泰语言包
		'vn': require('./utils/lang/yn'), // 越南语言包
    'kr': require('./utils/lang/hy') // 韩语语言包
	}
})

Vue.config.productionTip = false

axios.defaults.timeout = 20000 // 请求超时

axios.defaults.baseURL = window.GLOBAL.HOST;  // api 即上面 vue.config.js 中配置的地址

Vue.prototype.domain = window.GLOBAL.HOST;
Vue.prototype.socket_url = window.GLOBAL.webSocket;
Vue.prototype.adsHOST = window.GLOBAL.adsHOST;
Vue.prototype.webTitle = window.GLOBAL.title;
Vue.prototype.sqHost = window.GLOBAL.HOST2;
Vue.prototype.homeLogo = window.GLOBAL.homeLogo;
document.title = window.GLOBAL.title;

axios.interceptors.request.use(function(config){
  store.state.isLoad = false; //在请求发出之前进行一些操作
  if(config.method === 'post') {
    config.data = {
      lang: localStorage.getItem('user_lang') || 'en',
      app: 'h5',
      rtoken: randomRange(6,16),
      token: localStorage.getItem('token') || 1,
      ...config.data
    }
  }else if (config.method === 'get') {
    config.params = {
      lang: localStorage.getItem('user_lang') || 'en',
      app: 'h5',
      rtoken: randomRange(6,16),
      token: localStorage.getItem('token') || 1,
      ...config.params
    }
  }
  return config
})

//定义一个响应拦截器
axios.interceptors.response.use(function(config){
  store.state.isLoad = false;//在这里对返回的数据进行处理
  return config
})

Vue.prototype.$ajax = axios;

Vue.use(Toast,{
  type: 'center',
  duration: 3000,
  wordWrap: true,
})
Vue.use(VueClipboard)

Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])//插入过滤器名和对应方法
})

router.beforeEach((to, from, next) => {
  const fullPath = to.fullPath;
  var reloaded = localStorage.getItem('reloaded') || '';
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
      if (localStorage.getItem('token')) {  // 通过vuex state获取当前的token是否存在
        next();
      }else {
        next({
          path: '/index',
          query: {redirect: fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
  }else {
    next();
  }
})
function randomRange(min,max) {
	var returnStr = "",
	range = (max ? Math.round(Math.random() * (max-min)) + min : min),
	arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
	for(var i=0; i<range; i++){
		var index = Math.round(Math.random() * (arr.length-1));
		returnStr += arr[index];
	}
	return returnStr;
};
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js